var map = {
	"./przybornik_gumka.png": "bd76",
	"./przybornik_kosz.png": "ae30",
	"./przybornik_menuRysuj_ON.png": "935b",
	"./przybornik_okrag.png": "b598",
	"./przybornik_pedzel.png": "f92a",
	"./przybornik_prostokat.png": "d0c0",
	"./przybornik_wielkosc1.png": "6493f",
	"./przybornik_wielkosc2.png": "4575",
	"./przybornik_wielkosc3.png": "73e4",
	"./przybornik_wielkosc4.png": "b6bc",
	"./przybornik_wielkosc5.png": "9ca3c",
	"./przybornik_wielkosc6.png": "1755",
	"./przybornik_wielkosc7.png": "95f1",
	"./przybornik_wyroznij.png": "bd03",
	"./przybornik_zakoncz.png": "66ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80a7";